import React, { useContext } from 'react';
import removeMd from 'remove-markdown';

import { cloudinaryUrl } from 'utils';
import SEO from 'common/seo';
import ContributeContext from '../context';

const ContributeSEO = () => {
    const { campaign } = useContext(ContributeContext);

    const metaTitle = `Give to "${campaign.name}"`;

    let metaDescription = removeMd(campaign.description ?? '');
    if (metaDescription.length > 250) metaDescription = `${metaDescription.substr(0, 250)}…`;

    const image = campaign.heroImage?.publicId ?? 'facebook-default.png';
    const metaImage = cloudinaryUrl(image, { transformation: 'facebook', secure: false });
    const metaImageSecure = cloudinaryUrl(image, { transformation: 'facebook', secure: true });

    return (
        <SEO>
            <title>{metaTitle}</title>
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />

            <meta property="og:image" content={metaImage} />
            <meta property="og:image:secure_url" content={metaImageSecure} />
            <meta name="twitter:image" content={metaImageSecure} />
        </SEO>
    );
};

export default ContributeSEO;
